import { useIntl } from '@leagueplatform/locales';
import { MainPageContainer } from '@leagueplatform/web-common-components';
import { useNavigate } from 'react-router-dom';
import {
  MasonryWSDriverConfig,
  getMasonryWSRootNode,
} from '@leagueplatform/masonry-api';
import { wsDriver } from '@leagueplatform/masonry';
import { MasonryEngine } from '@leagueplatform/masonry-engine';
import {
  PRODUCT_AREA,
  SCREEN_NAMES,
  usePageViewAnalytics,
} from '@leagueplatform/analytics';
import { StackLayout, styled } from '@leagueplatform/genesis-core';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { HeroSection } from 'components/hero-section/hero-section.component';

const config: MasonryWSDriverConfig = {
  appId: 'scfhp_care_homepage_left',
  screenName: SCREEN_NAMES.HOMEPAGE,
  productArea: PRODUCT_AREA.GET_CARE,
};

const MasonryFormsPageRootNode = getMasonryWSRootNode(config);

const FullWidthVerticalMasonry = styled('div', {
  width: '100%',
  '& > div > div > div': {
    width: '100%',
  },
  '& > div > div > div > div': {
    width: '100%',
    maxWidth: '100%',
  },
});

export const TempCareLandingPage = () => {
  const navigate = useNavigate();
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: 'STR_GET_CARE' }));

  usePageViewAnalytics({
    product_area: PRODUCT_AREA.CARE,
    screen_name: 'get care page',
  });

  return (
    <MainPageContainer
      width="100%"
      css={{
        '.GDS-vertical-stack-layout': {
          width: '100%',
        },
      }}
    >
      <HeroSection
        title={formatMessage({ id: 'STR_GET_CARE' })}
        goBack={() => {
          navigate(-1);
        }}
        height="154px"
      />

      <StackLayout orientation="vertical">
        <FullWidthVerticalMasonry
          css={{
            paddingTop: '$three',
            paddingBottom: '$five',
          }}
        >
          <MasonryEngine
            driver={wsDriver}
            rootNode={MasonryFormsPageRootNode}
          />
        </FullWidthVerticalMasonry>
      </StackLayout>
    </MainPageContainer>
  );
};
